<template>
  <div>
    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">任务管理</span>
        <span style="float:right;">
          <span>选择年份：</span>
          <el-select v-model="currentYear" placeholder="请选择年份" @change="getList">
            <el-option label="2024年" :value="2024"></el-option>
            <el-option label="2025年" :value="2025"></el-option>
            <el-option label="2026年" :value="2026"></el-option>
          </el-select>
        </span>
      </div>

      <!-- 内容区域 -->
      <div class="content-container">
        <!-- 左侧年度日历视图 -->
        <div class="calendar-section">
          <div class="year-title">
            <i class="el-icon-s-order" style="color: #409eff;font-size: 22px;"></i>
            {{ currentYear }}年任务
          </div>
          <div class="month-grid">
            <div
              v-for="(month, index) in months"
              :key="index"
              class="month-card"
              :class="{
                'active': selectedMonth === month.month,
                'has-target': month.hasTarget,
                'no-target': !month.hasTarget
              }"
              @click="selectMonth(month.month)"
            >
              <div class="month-header">{{ month.month }}月</div>
              <div class="month-content" v-if="month.hasTarget">
                <div class="target-info">
                  <div class="target-number">{{ month.total }}</div>
                  <div class="target-label">已签约：{{month.finished}} 家</div>
                </div>
              </div>
              <div class="no-target-tip" v-else>
                <i class="el-icon-warning-outline"></i>
                <div>未设置任务目标</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧任务详情 -->
        <div class="detail-section">
          <div v-if="selectedMonth && monthDetail.hasTarget" class="detail-content">
            <!-- 部门总目标 -->
            <div class="department-target-card">
              <div class="target-title">
                <div>
                <i class="el-icon-office-building"></i>
                {{ selectedMonth }}月份部门总目标
                </div>
                <div>
                  <el-button type="warning" icon="el-icon-tickets" size="small" @click="createDepartmentTask">任务分配</el-button>
                </div>
              </div>
              <div class="target-summary">
                <div class="summary-item">
                  <span class="label">目标签约客户数：</span>
                  <span class="value">{{ monthDetail.departmentTarget }}家</span>
                </div>
                <div class="summary-item">
                  <span class="label">已完成签约：</span>
                  <span class="value completed">{{ monthDetail.completed }}家</span>
                </div>
                <div class="summary-item">
                  <span class="label">完成进度：</span>
                  <span class="value">{{ monthDetail.completionRate }}%</span>
                </div>
              </div>

            </div>

            <!-- 小组目标 -->
            <div class="groups-section">
              <div class="section-title">
                <i class="el-icon-user-solid"></i>
                小组目标任务
              </div>
              <div class="groups-grid">
                <div
                  v-for="group in monthDetail.groups"
                  :key="group.id"
                  class="group-card"
                >

                <div class="group-head">
                  <div class="group-progress">
                    <el-progress type="dashboard" :stroke-width="8" :width="80" :percentage="group.target ? Math.min(100, Math.ceil(group.completed / group.target * 100)) : 0" :format="() => group.target ? `${Math.ceil(group.completed / group.target * 100)}%` : '0%'"></el-progress>
                  </div>
                  <div class="group-title-container">
                    <div class="flex-div">
                      <div class="group-name">{{ group.name }}</div>
                      <div>
                        <el-button plain type="warning" icon="el-icon-tickets" size="mini" @click="getGroupTaskDetail(group)">任务分配</el-button>
                      </div>
                    </div>
                    <div class="flex-div">
                      <div class="group-text">小组进度：{{ group.completed }} / {{ group.target }} 家</div>
                    </div>
                    <div class="flex-div">
                      <div class="group-text">负责人：{{ group.leader }}</div>
                      <div class="group-text">完成：{{ (group.members.find(item => item.name===group.leader) || {}).completed || 0 }} 家</div>
                    </div>
                  </div>
                </div>

                <!-- 小组成员目标 -->
                <div class="members-section">
                  <div class="members-list">
                    <div
                      v-for="(member,index) in group.members.filter(item=>item.name!==group.leader)"
                      :key="member.id"
                      class="member-item"
                    >
                      <div class="member-name"> {{ index+1 }}. {{ member.name }}</div>
                      <div v-if="member.target===null" class="member-target null">
                        未分配任务
                      </div>
                      <div v-if="member.target!==null" class="member-target">
                        目标：{{ member.target }}
                      </div>
                      <div class="member-finished">
                        已完成：{{ member.completed }}
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 无任务提示 -->
          <div v-else-if="selectedMonth && !monthDetail.hasTarget" class="no-target-detail">
            <div class="no-target-icon">
              <i class="el-icon-warning-outline"></i>
            </div>
            <div class="no-target-message">
              <h3>本月尚未设置部门目标</h3>
              <p>请先设置部门目标，再为各小组分配具体任务</p>
              <el-button type="primary" @click="createDepartmentTask">立即设置目标</el-button>
            </div>
          </div>

          <!-- 未选择月份提示 -->
          <div v-else class="no-selection-tip">
            <div class="tip-icon">
              <i class="el-icon-date"></i>
            </div>
            <div class="tip-message">
              <h3>请选择月份查看详情</h3>
              <p>点击左侧日历中的月份查看目标任务详情</p>
            </div>
          </div>
        </div>

      </div>
    </el-card>

    <!-- 设置部门目标对话框 -->
    <el-dialog
      :title="departmentTaskData.year + '年' + departmentTaskData.month + '月部门任务'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-form :model="departmentTaskData" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <el-form-item label="部门任务数：">
              <el-input-number v-model="departmentTaskData.total" :min="0" label="部门任务数"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <div style="color: #409EFF; font-size: 18px;height: 40px;line-height: 40px;">
              <i class="el-icon-info"></i>
              剩余可分配额度：{{ departmentTaskData.total - calculateDepartmentTotal() }}
            </div>
          </el-col>
        </el-row>
        <el-table :data="departmentTaskData.groupTasks" style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="departmentId" label="小组名称" width="200"></el-table-column>
          <el-table-column prop="total" label="任务数">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.total"
                :min="0"
                size="small"
                @change="handleMemberTargetChange">
              </el-input-number>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitDepartmentTask">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 小组任务分配对话框 -->
    <el-dialog
      :title="groupTaskData.year + '年' + groupTaskData.month + '月' + groupTaskData.name + '任务分配'"
      :visible.sync="groupTaskDialogVisible"
      width="50%"
      :before-close="handleGroupTaskClose"
    >
      <el-form label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <el-form-item label="小组总任务：">
              <el-input-number v-model="groupTaskData.target" :min="0" disabled></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <div style="color: #409EFF; font-size: 18px;height: 40px;line-height: 40px;">
              <i class="el-icon-info"></i>
              剩余可分配额度：{{ groupTaskData.target - calculateMemberTotal() }}
            </div>
          </el-col>
        </el-row>

        <el-table :data="groupTaskData.members" style="width: 100%" height="450">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="name" label="成员姓名" width="150"></el-table-column>
          <el-table-column prop="target" label="任务数">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.target"
                :min="0"
                size="small"
                @change="handleMemberTargetChange">
              </el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="completed" label="已完成" width="100"></el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="groupTaskDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitGroupTask">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      months: [],
      monthDetail: {
        hasTarget: false,
        departmentTarget: 0,
        completed: 0,
        completionRate: 0,
        groups: []
      },
      // 添加设置部门目标功能所需的数据
      dialogVisible: false,
      departmentTaskData: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        total: 0,
        groupTasks: []
      },
      // 添加小组任务分配功能所需的数据
      groupTaskDialogVisible: false,
      groupTaskData: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        name: '',
        target: 0,
        completed: 0,
        leader: '',
        members: []
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取列表
    async getList () {
      const { data: res } = await this.$http.get('zhaoshang/renwu/list', {
        params: {
          year: this.currentYear
        }
      })
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }
      this.months = res.data
      this.selectMonth(this.selectedMonth)
    },

    // 选择月份
    selectMonth (month) {
      this.selectedMonth = month
      this.loadMonthDetail(month)
    },

    // 加载月份详情
    async loadMonthDetail (month) {
      const { data: res } = await this.$http.get('zhaoshang/renwu/detail', {
        params: {
          year: this.currentYear,
          month
        }
      })
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }
      this.monthDetail = res.data
    },

    // 新建部门任务
    async createDepartmentTask () {
      const { data: res } = await this.$http.get('zhaoshang/renwu/departmentTaskDetail', {
        params: {
          year: this.currentYear,
          month: this.selectedMonth
        }
      })
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      // 更新departmentTaskData
      this.departmentTaskData = {
        year: res.data.year,
        month: res.data.month,
        total: res.data.total,
        groupTasks: res.data.groupTasks.map(item => ({ ...item }))
      }

      // 显示对话框
      this.dialogVisible = true
    },

    // 提交部门任务设置
    async submitDepartmentTask () {
      // 计算小组任务数总和
      const groupTotal = this.departmentTaskData.groupTasks.reduce((sum, item) => sum + item.total, 0)

      // 校验部门小组任务数总和是否等于部门任务数
      if (groupTotal !== this.departmentTaskData.total) {
        return this.$message.error('部门小组任务数总和必须等于部门任务数')
      }

      // 二次确认
      const confirmResult = await this.$confirm('确定要设置部门目标吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => {})

      if (confirmResult !== 'confirm') {
        return
      }

      // 调用部门任务设置接口
      const { data: res } = await this.$http.post('zhaoshang/renwu/assignMaster', {
        year: this.departmentTaskData.year,
        month: this.departmentTaskData.month,
        total: this.departmentTaskData.total,
        groupTasks: this.departmentTaskData.groupTasks
      })

      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      // 关闭对话框
      this.dialogVisible = false
      this.$message.success('部门目标设置成功')

      this.getList()
    },

    // 处理小组任务分配对话框关闭
    handleGroupTaskClose (done) {
      // 直接关闭对话框，无需二次确认
      done()
    },

    // 处理成员任务数变化
    handleMemberTargetChange () {
      // 这里可以添加一些验证逻辑，比如实时显示总和是否匹配
    },

    // 计算成员任务总数
    calculateMemberTotal () {
      return this.groupTaskData.members.reduce((sum, member) => sum + (member.target || 0), 0)
    },

    // 计算部门任务总数
    calculateDepartmentTotal () {
      return this.departmentTaskData.groupTasks.reduce((sum, item) => sum + (item.total || 0), 0)
    },

    // 获取小组任务详情
    async getGroupTaskDetail (group) {
      const { data: res } = await this.$http.get('zhaoshang/renwu/groupTaskDetail', {
        params: {
          year: this.currentYear,
          month: this.selectedMonth,
          departmentId: group.name
        }
      })

      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      // 更新groupTaskData
      this.groupTaskData = {
        year: res.data.year,
        month: res.data.month,
        name: res.data.name,
        target: res.data.target,
        completed: res.data.completed,
        leader: res.data.leader,
        members: res.data.members.map(member => ({ ...member }))
      }

      // 显示对话框
      this.groupTaskDialogVisible = true
    },

    // 提交小组任务分配
    async submitGroupTask () {
      // 计算成员任务数总和
      const memberTotal = this.calculateMemberTotal()

      // 校验成员任务数总和是否等于小组任务数
      if (memberTotal !== this.groupTaskData.target) {
        return this.$message.error('成员任务数总和必须等于小组总任务数')
      }

      // 二次确认
      const confirmResult = await this.$confirm('确定要分配小组任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => {})

      if (confirmResult !== 'confirm') {
        return
      }

      // 准备提交数据
      const employeeTasks = this.groupTaskData.members
        .filter(member => member.id) // 过滤掉没有ID的成员
        .map(member => ({
          employeeId: member.id,
          total: member.target
        }))

      // 调用小组任务设置接口
      const { data: res } = await this.$http.post('zhaoshang/renwu/assignSlave', {
        year: this.groupTaskData.year,
        month: this.groupTaskData.month,
        departmentId: this.groupTaskData.name,
        employeeTasks
      })

      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      // 关闭对话框
      this.groupTaskDialogVisible = false
      this.$message.success('小组任务分配成功')

      // 重新加载数据
      this.loadMonthDetail(this.selectedMonth)
    }
  }
}
</script>

<style lang="less">
  .group-progress{
    .el-progress__text{
      font-size:12px!important;
    }
  }
</style>

<style lang="less" scoped>
// ==================== Element UI 色彩变量 ====================
@primary-deep: #1e86ed;
@primary-color: #409EFF;
@primary-light: #79bbff;
@primary-lighter: #a0cfff;
@success-color: #67C23A;
@warning-color: #E6A23C;
@danger-color: #F56C6C;
@info-color: #909399;

// ==================== Element UI 文字颜色 ====================
@text-primary: #303133;
@text-regular: #606266;
@text-secondary: #909399;
@text-placeholder: #C0C4CC;

// ==================== Element UI 边框颜色 ====================
@border-base: #DCDFE6;
@border-light: #E4E7ED;
@border-lighter: #EBEEF5;
@border-extra-light: #F2F6FC;

// ==================== Element UI 背景颜色 ====================
@bg-white: #FFFFFF;
@bg-page: #F2F3F5;
@bg-overlay: #EDF2FC;

// ==================== Element UI 阴影效果 ====================
@box-shadow-base: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
@box-shadow-dark: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .12);
@box-shadow-light: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

// ==================== 页面布局容器 ====================
// 定义页面的主要布局结构，包括内容区域的整体样式
.box-card {
  .flexContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.content-container {
  display: flex;
  gap: 24px;
  min-height: 600px;
}

/* 左侧日历区域 */
// 定义页面左侧的日历展示区域，包含年份标题、月份网格布局和月份卡片样式
.calendar-section {
  flex: 0 0 360px;
  background: @bg-white;
  border: 1px solid @border-light;
  border-radius: 12px;
  padding: 25px;
  padding-top:25px;
  // box-shadow: @primary-light 0 0 0 1px;

  .year-title {
    font-size: 20px;
    font-weight: 600;
    color: #4f5154;
    text-align: left;
    // margin-bottom: 30px;
    padding-bottom: 30px;
    // border-bottom: 1px solid @primary-lighter;
  }

  .month-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  .month-card {
        height: 90px;
        background: @bg-white;
        border: 1px solid @border-lighter;
        border-radius: 4px;
        padding: 12px;
        cursor: pointer;
        // transition: all 0.3s ease;

        &:hover {
          border-color: @primary-color;
          box-shadow: @box-shadow-light;
          transform: translateY(-2px);
        }

        &.active {
          border-color: @primary-color;
          box-shadow: 0 0  10px 1px @primary-color;
          // background: linear-gradient(135deg, #f0f8ff, #e6f2ff);
        }

    &.has-target {
      // background: linear-gradient(-25deg, #e6f2fe 0%, @bg-white 85%, @primary-color 100%);
      background:#f0f7ff
    }

    &.no-target {
      // opacity: 0.8;
      background: #fafafa;
    }

    .month-header {
      font-size: 16px;
      // font-weight: 600;
      color: @text-primary;
      text-align: left;
      margin-bottom: 10px;
    }

    .month-content {
      .target-info {
        text-align: center;
        // margin-bottom: 8px;

        .target-number {
          font-size: 26px;
          font-weight: bold;
          color: @primary-color;
          // line-height: 1;
          margin-top:5px;
        }

        .target-label {
          font-size: 11px;
          color: @text-secondary;
          margin-top: 8px;
        }
      }
    }

    .no-target-tip {
      text-align: center;
      color: @text-placeholder;
      font-size: 11px;
      margin-top:15px;

      i {
        font-size: 20px;
        margin-bottom: 4px;
        display: block;
      }
    }
  }
}

/* 右侧详情区域 */
// 定义页面右侧的任务详情展示区域，包含部门总目标、小组目标和成员目标的详细信息
.detail-section {
  flex: 1;
  background: @bg-white;
  border: 1px solid @border-light;
  border-radius: 12px;
  padding: 24px;
  // box-shadow: @box-shadow-base;

  .no-selection-tip,
  .no-target-detail {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
    text-align: center;

    .tip-icon,
    .no-target-icon {
      i {
        font-size: 48px;
        color: @text-placeholder;
        margin-bottom: 16px;
      }
    }

    h3 {
      font-size: 18px;
      color: @text-primary;
      margin: 0 0 8px 0;
      font-weight: 600;
    }

    p {
      font-size: 14px;
      color: @text-secondary;
      margin: 0 0 20px 0;
      line-height: 1.5;
    }

    .el-button {
      padding: 12px 20px;
      font-weight: 500;
      border-radius: 4px;

      &:hover {
        transform: translateY(-1px);
        box-shadow: @box-shadow-light;
      }
    }
  }

  .detail-content {
    .department-target-card {
      // background: linear-gradient(135deg, #367fcc 0%, #409EFF 100%);
      background: linear-gradient(135deg, @primary-deep 0%, @primary-color 100%);
      color: white;
      border-radius: 6px;
      padding: 24px;
      margin-bottom: 24px;
      box-shadow: @box-shadow-dark;
      border: 1px solid rgba(64, 158, 255, 0.3);

      .target-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        i {
          margin-right: 4px;
          font-size: 20px;
        }
      }

      .target-summary {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        margin-bottom: 20px;

        .summary-item {
          text-align: center;
          padding: 12px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          backdrop-filter: blur(10px);

          .label {
            display: block;
            font-size: 13px;
            // opacity: 0.9;
            margin-bottom: 4px;
            font-weight: 500;
          }

          .value {
            display: block;
            font-size: 20px;
            font-weight: bold;

            &.completed {
              color: rgba(255, 255, 255, 0.9); // 使用白色与蓝色背景更和谐
            }
          }
        }
      }

    }

    .groups-section {
      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: @text-primary;
        margin-bottom: 16px;
        display: flex;
        align-items: center;

        i {
          margin-right: 8px;
          color: @primary-color;
          font-size: 18px;
        }
      }

      .groups-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 16px;
      }

      .group-card {
        background: @bg-white;
        border: 1px solid @border-light;
        border-top: 4px solid @primary-light;
        border-radius: 4px;
        padding: 20px;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: @box-shadow-light;
          transform: translateY(-2px);
          border-color: @primary-light;
        }

        .group-head{
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;

          .group-progress{
            width: 100px;
            padding-top:10px;

          }

          .group-title-container{
            width:100%;
            padding-right:14px;

            .flex-div{
              padding:2px 0px;
              display: flex;
              justify-content:space-between;
              // width:100%;
              margin-left:20px;
              align-items:center;

              .group-name{
                font-size:16px;
              }

              .group-text{
                font-size:12px;
                color:@text-secondary;
              }

            }
          }
        }

        .members-section {
          .members-title {
            font-size: 13px;
            font-weight: 600;
            color: @text-regular;
            margin-bottom: 8px;
          }

          .members-list {
            .member-item {
              display: flex;
              width: 100%;
              align-items: center;
              justify-content: space-between;
              padding: 8px 0;
              border-bottom: 1px dashed @border-base;
              transition: all 0.2s ease;

              &:hover {
                background: rgba(64, 158, 255, 0.03);
                margin: 0 -8px;
                padding: 8px 8px;
                border-radius: 4px;
                border-bottom-color: transparent;
              }

              &:last-child {
                border-bottom: none;
              }

              .member-name {
                font-size: 13px;
                color: @text-primary;
                min-width: 70px;
                // font-weight: 600;
              }

              .member-target {
                font-size: 12px;
                color: @primary-color;
                text-align: left;
                min-width: 70px;
                // font-weight: 500;
              }

              .member-target.null {
                font-size: 12px;
                color: @danger-color;
                text-align: left;
                min-width: 70px;
              }

              .member-finished {
                font-size: 12px;
                color: @success-color;
                text-align: left;
                min-width: 70px;
                // font-weight: 500;
              }

            }
          }
        }
      }
    }
  }
}

/* 响应式设计 */
// 定义不同屏幕尺寸下的布局调整，确保在各种设备上都有良好的显示效果
@media (max-width: 1200px) {
  .content-container {
    flex-direction: column;
  }

  .calendar-section {
    flex: none;
    width: 100%;
  }

  .month-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .calendar-section {
    padding: 16px;

    .month-grid {
      grid-template-columns: repeat(3, 1fr);
      gap: 8px;
    }
  }

  .detail-section {
    padding: 16px;
  }

  .target-summary {
    grid-template-columns: 1fr !important;
    gap: 8px !important;
  }

  .groups-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>
